const MESSAGE_TYPES = {
  SLIDE_OPTION: 'slideOption',
}

const ACTIONS = {
  UPDATE_SLIDE_OPTION: 'update',
  CREATE_SLIDE_OPTION: 'create',
  BULK_CREATE_SLIDE_OPTIONS: 'bulk-create',
  DELETE_SLIDE_OPTION: 'delete',
  SORT_SLIDE_OPTION: 'sort',
}

const getSlideOptionIndex = (arr, id) => {
  return arr.findIndex((item) => {
    return id == item.id
  })
}

function handleUpdateSlideOption(doc, slide) {
  const indexOption = getSlideOptionIndex(slide.SlideOptions, doc.data.id)
  if (indexOption != -1) {
    slide.SlideOptions[indexOption].title = doc.data.title
    slide.SlideOptions[indexOption].order = doc.data.order
    slide.SlideOptions[indexOption].correct = doc.data.correct
    slide.SlideOptions[indexOption].image = doc.data.image
    slide.SlideOptions[indexOption].pairTitle = doc.data.pairTitle
    slide.SlideOptions[indexOption].imageCropped = doc.data.imageCropped
  }
}

function handleCreateSlideOption(doc, slide) {
  slide.SlideOptions.push(doc.data)
}

function handleBulkCreateSlideOptions(doc, slide) {
  slide.SlideOptions.push(...doc.data)
}

function handleDeleteSlideOption(doc, slide) {
  const indexOption = getSlideOptionIndex(slide.SlideOptions, doc.data.id)
  if (indexOption != -1) {
    slide.SlideOptions.splice(indexOption, 1)
  }
  if (slide.radioSelectded == doc.data.id) {
    slide.radioSelectded = null
  }
}

function handleSortSlideOption(doc, slide) {
  const { updatedSlideOption } = doc.data

  slide.SlideOptions.forEach((item) => {
    if (item.id === updatedSlideOption.id) {
      item.order = updatedSlideOption.order
    }
  })
}

function handleSlideOptionMessages(doc, rootComponent) {
  const slide = rootComponent.$store.getters.activeActivity
  if (slide.id != doc.data.slideId) return
  let shouldSort = false
  if (doc.action === ACTIONS.UPDATE_SLIDE_OPTION) {
    handleUpdateSlideOption(doc, slide)
    shouldSort = true
  } else if (doc.action === ACTIONS.CREATE_SLIDE_OPTION) {
    handleCreateSlideOption(doc, slide)
    shouldSort = true
  } else if (doc.action === ACTIONS.BULK_CREATE_SLIDE_OPTIONS) {
    handleBulkCreateSlideOptions(doc, slide)
    shouldSort = true
  } else if (doc.action === ACTIONS.DELETE_SLIDE_OPTION) {
    handleDeleteSlideOption(doc, slide)
  } else if (doc.action === ACTIONS.SORT_SLIDE_OPTION) {
    handleSortSlideOption(doc, slide)
    shouldSort = true
  }

  if (shouldSort) {
    slide.SlideOptions.sort((a, b) => a.order - b.order)
  }
}

const SlideOptionWebSocketSubscriber = {
  [MESSAGE_TYPES.SLIDE_OPTION]: handleSlideOptionMessages,
}

export default SlideOptionWebSocketSubscriber
